<template>
  <div>
    <div
      :class="{
        'nav-btn d-none d-lg-flex flex-column align-items-center justify-content-center mx-2 notif-drop-toggle': true,
        selected: isOpen,
      }"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <img src="../../assets/nav-icons/bell.svg" alt="notification button" />
      <div class="pt-2">
        <span>Notifications</span>
        <span v-if="unreadCount" class="badge badge-danger ml-1">{{
          unreadCount
        }}</span>
      </div>
    </div>

    <div class="btn-group mr-2 d-none d-lg-block">
      <div class="dropdown-menu dropdown-menu-right notif-dropdown">
        <ul v-if="notifications.length" class="list-group list-group-flush">
          <li
            v-for="notif in notifications"
            :key="notif.id"
            :class="{
              'list-group-item': true,
              'list-item-notif': true,
              'notif-unread': !notif.hasRead,
            }"
          >
            <a @click="notifClicked(notif)" class="notif-link">
              <p class="notif-name">{{ notif.name }}</p>
              <p class="notif-desc">{{ notif.description }}</p>
            </a>
          </li>
        </ul>
        <div class="px-4 py-2 d-flex" v-else>
          <i class="material-icons pr-2">info_outline</i>
          There are no notifications to display
        </div>
      </div>
    </div>
    <!-- ^ desktop ^ -->

    <div class="btn-group mr-2 d-block d-lg-none">
      <div class="card mt-2">
        <button
          id="notifBtn"
          class="card-header btn btn-primary d-flex py-3 rounded"
          data-toggle="collapse"
          data-target="#notifs"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          <i class="material-icons" style="margin-right: 7px">notifications</i>
          <span>Notifications</span>
        </button>
        <div
          id="notifs"
          class="collapse"
          aria-labelledby="notifBtn"
          data-parent="#notifs"
        >
          <div class="card-body" v-if="notifications.length">
            <div class>
              <ul class="list-group list-group-flush">
                <li
                  v-for="notif in notifications"
                  :key="notif.id"
                  :class="{
                    'list-group-item': true,
                    'list-item-notif': true,
                    'notif-unread': !notif.hasRead,
                  }"
                >
                  <a
                    @click="notifClicked(notif.id)"
                    class="notif-link"
                    :href="notif.link"
                  >
                    <p class="notif-name">{{ notif.name }}</p>
                    <p class="notif-desc">{{ notif.description }}</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="px-4 py-2 d-flex" v-else>
            <i class="material-icons pr-2">info_outline</i>
            There are no notifications to display
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ^ mobile ^ -->
</template>
<script>
import userService from "../../services/user.service";

export default {
  name: "NotificationDropdown",
  data: function () {
    return {
      pollInterval: null,
      notifications: [],
      isOpen: false,
    };
  },
  computed: {
    unreadCount() {
      return this.notifications.filter((n) => !n.hasRead).length;
    },
  },
  created() {
    this.refreshNotifications();

    this.pollInterval = setInterval(() => {
      if (this.$route.path.toLowerCase() === "/login") return;

      this.refreshNotifications();
    }, 1000 * 60);
  },
  mounted() {
    $(".notif-drop-toggle")
      .parent()
      .on("hidden.bs.dropdown", () => {
        this.isOpen = false;
      })
      .on("shown.bs.dropdown", () => {
        this.isOpen = true;
      });
  },
  methods: {
    refreshNotifications() {
      userService.myNotifications().then(
        (data) =>
          (this.notifications = data.map((n) => {
            return {
              id: n.id,
              name: n.name,
              description: n.description,
              link: n.link,
              hasRead:
                n.notifications_users.length > 0
                  ? n.notifications_users[0].has_read
                  : false,
            };
          }))
      );
    },
    notifClicked(notification) {
      this.notifications.find((n) => n.id === notification.id).hasRead = true;
      userService.markNotificationRead(notification.id).finally(() => {
        window.location.href = notification.link;
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 991px) {
  .btn-group {
    width: 100%;
  }
}

.btn.btn-primary.dropdown-toggle-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.notif-name {
  margin: 0;
}

.notif-desc {
  margin: 0;
  text-overflow: ellipsis;
  font-size: 0.8em;
}

.notif-dropdown {
  width: 20rem;
  max-height: 500px;
  overflow: scroll;
  overflow-x: hidden;
}

.notif-unread {
  background: rgba(255, 152, 23, 0.1) !important;
}

.list-item-notif {
  background: var(--white);
}
</style>
